<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                    <div>
                        <el-button type="warning" @click="addShoppingNumDialog = true">添加
                        </el-button>
                    </div>
                </div>
            </div>

            <el-table :data="residentList" header-row-class-name="table-header" row-class-name="table-row" alig="center"
                border style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="库存" prop="num"></el-table-column>
                <el-table-column label="操作" width="320px">
                    <template slot-scope="scope">
                        <div class="flex align-center justify-center">
                            <el-popover placement="bottom" v-model="scope.row.addVisible">
                                <div class="flex align-center" v-if="scope.row.addVisible">
                                    <el-input-number key="add" type="number" v-model="change_num" :min="1" :step="1"
                                        :precision="0" controls-position="right"
                                        placeholder="请输入添加数量"></el-input-number>
                                    <el-button class="margin-left-xs" type="primary" size="mini"
                                        @click="changeNum(scope.$index, scope.row.id, 1)">
                                        确定
                                    </el-button>
                                </div>
                                <el-button slot="reference" size="mini" type="primary">添加</el-button>
                            </el-popover>
                            <el-popover placement="bottom" v-model="scope.row.delVisible">
                                <div class="flex align-center" v-if="scope.row.delVisible">
                                    <el-input-number key="plus" type="number" v-model="change_num" :min="1" :step="1"
                                        :precision="0" controls-position="right" :max="scope.row.num"
                                        placeholder="请输入减少数量"></el-input-number>
                                    <el-button class="margin-left-xs" type="primary" size="mini"
                                        @click="changeNum(scope.$index, scope.row.id, 2)">
                                        确定
                                    </el-button>
                                </div>
                                <el-button class="margin-lr-sm" slot="reference" size="mini" type="primary">
                                    减少
                                </el-button>
                            </el-popover>
                            <el-button type="primary" size="mini" @click="delProductItem(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="residentList.length > 0" class="page-all" background @current-change="getResidentList"
                :current-page.sync="page" :page-size="limit" layout="prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <add-shopping-num-dialog :pid="id" :dialog="addShoppingNumDialog"
            @watchState="watchState"></add-shopping-num-dialog>
    </div>
</template>

<script>

import { delProductXiangmuNum, productXiangmuNumList, setProductXiangmuNum } from "@/api/weilao";
import AddShoppingNumDialog from "@/views/pages/dialog/AddShoppingNumDialog";

export default {
    name: "shopping-caozuo",
    components: { AddShoppingNumDialog },
    data() {
        return {
            id: '',
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],

            change_num: '',

            addShoppingNumDialog: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", '/home/shopping', "双暖为老 / 商城管理 / 分配库存", true);
        this.id = this.$route.query.id
        this.getResidentList()
    },
    methods: {
        //  获取商品列表
        async getResidentList() {
            let _data = await productXiangmuNumList(
                this.id,
                this.page,
                this.limit,
            )
            this.residentList = _data.data
            this.total = _data.total_number
        },
        async changeNum(index, id, type) {
            if (!this.change_num) return this.$message.error('请输入数量')
            let _data = await setProductXiangmuNum(id, type, this.change_num)
            if (_data.status === 200) {
                this.$message.success('操作成功')
                this.change_num = ''
                let _item = this.residentList[index]
                _item.addVisible = false
                _item.delVisible = false
                this.residentList.splice(index, 1, _item)
                this.getResidentList()
            } else {
                this.$message.error(_data.info)
            }
        },
        watchState(data) {
            this.addShoppingNumDialog = false
            if (data) this.getResidentList()
        },
        refreshList() {
            if (this.residentList.length <= 1 && this.page !== 1) this.page = this.page - 1
            this.getResidentList()
        },
        delProductItem(item) {
            this.$confirm('确定删除该库存？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.delProduct(item)
            });
        },
        async delProduct(item) {
            let _data = await delProductXiangmuNum(item.id)
            if (_data.status === 200) {
                this.$message.success('删除成功')
                this.refreshList()
            } else {
                this.$message.error(_data.info)
            }
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss"></style>
